import { createSlice } from '@reduxjs/toolkit'

const slice = createSlice({
  name: 'tutorManagement',
  initialState: {
    // Tutor Type
    tutorTypeList: [],
    tutorTypeListLoading: false,
    tutorTypePaginationData: {},
    tutorTypeDetails: {},
    tutorTypeDetailsLoading: false,
    updateTutorType: false,

    // Tutor Category
    tutorCategoryList: [],
    tutorCategoryListLoading: false,
    tutorCategoryPaginationData: {},
    tutorCategoryDetails: {},
    tutorCategoryDetailsLoading: false,
    updateTutorCategory: false,

    // Tutor Sub Category
    tutorSubCategoryList: [],
    tutorSubCategoryListLoading: false,
    tutorSubCategoryPaginationData: {},
    tutorSubCategoryDetails: {},
    tutorSubCategoryDetailsLoading: false,
    updateTutorSubCategory: false,

    // Tutor Curriculum
    tutorCurriculumList: [],
    tutorCurriculumListLoading: false,
    tutorCurriculumPaginationData: {},
    tutorCurriculumDetails: {},
    tutorCurriculumDetailsLoading: false,
    updateTutorCurriculum: false,

    // Tutor List (approval queue)
    tutorList: [],
    tutorListLoading: false,
    tutorPaginationData: {},
    tutorDetails: {},
    tutorDetailsLoading: false,
    updateTutor: false,
    tutorVerificationLoading: false,

    // State (tutor list filter)
    tutorStateList: [],
    tutorStateListLoading: false,

    // Country (common)
    countryList: [],
    countryListLoading: false,

    modalOpen: false,
    ApiError: '',
  },
  reducers: {
    // ================= Tutor Type (full CRUD) =================
    getTutorTypeListApiData: (state) => {
      state.tutorTypeListLoading = true
    },
    getTutorTypeListApiSuccess: (state, { payload }) => {
      state.tutorTypeListLoading = false
      state.tutorTypeList = payload?.payload?.data || []
      state.tutorTypePaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getTutorTypeListApiFailed: (state, { payload }) => {
      state.tutorTypeListLoading = false
      state.ApiError = payload?.message
    },

    getTutorTypeDetailsApiData: (state) => {
      state.tutorTypeDetailsLoading = true
    },
    getTutorTypeDetailsApiSuccess: (state, { payload }) => {
      state.tutorTypeDetailsLoading = false
      state.tutorTypeDetails = payload?.payload?.data || {}
    },
    getTutorTypeDetailsApiFailed: (state, { payload }) => {
      state.tutorTypeDetailsLoading = false
      state.ApiError = payload?.message
    },

    addTutorTypeApiData: (state) => {
      state.tutorTypeListLoading = true
      state.updateTutorType = false
      state.modalOpen = false
    },
    addTutorTypeApiSuccess: (state, { payload }) => {
      state.tutorTypeListLoading = false
      state.updateTutorType = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    addTutorTypeApiFailed: (state, { payload }) => {
      state.tutorTypeListLoading = false
      state.updateTutorType = false
      state.ApiError = payload?.message
    },

    updateTutorTypeApiData: (state, { payload }) => {
      state.updateTutorType = false
      state.tutorTypeList = state.tutorTypeList.map((item) =>
        item.id === payload?.id ? { ...item, ...payload } : item,
      )
    },
    updateTutorTypeApiSuccess: (state, { payload }) => {
      state.updateTutorType = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    updateTutorTypeApiFailed: (state, { payload }) => {
      state.updateTutorType = false
      state.ApiError = payload?.message
    },

    deleteTutorTypeApiData: (state, { payload }) => {
      state.tutorTypeList = state.tutorTypeList?.filter((item) => item.id !== payload?.id)
      state.updateTutorType = false
    },
    deleteTutorTypeApiSuccess: (state, { payload }) => {
      state.updateTutorType = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    deleteTutorTypeApiFailed: (state, { payload }) => {
      state.updateTutorType = false
      state.ApiError = payload?.message
    },

    activeInactiveTutorTypeApiData: (state) => {
      state.tutorTypeListLoading = true
      state.updateTutorType = false
    },
    activeInactiveTutorTypeApiSuccess: (state, { payload }) => {
      state.tutorTypeListLoading = false
      state.updateTutorType = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      if (payload?.payload?.data) {
        const updated = payload.payload.data
        state.tutorTypeList = state.tutorTypeList.map((item) =>
          item.id === updated.id ? { ...item, is_active: updated.is_active } : item,
        )
      }
    },
    activeInactiveTutorTypeApiFailed: (state, { payload }) => {
      state.tutorTypeListLoading = false
      state.updateTutorType = false
      state.ApiError = payload?.message
    },

    // ================= Tutor Category (full CRUD) =================
    getTutorCategoryListApiData: (state) => {
      state.tutorCategoryListLoading = true
    },
    getTutorCategoryListApiSuccess: (state, { payload }) => {
      state.tutorCategoryListLoading = false
      state.tutorCategoryList = payload?.payload?.data || []
      state.tutorCategoryPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getTutorCategoryListApiFailed: (state, { payload }) => {
      state.tutorCategoryListLoading = false
      state.ApiError = payload?.message
    },

    getTutorCategoryDetailsApiData: (state) => {
      state.tutorCategoryDetailsLoading = true
    },
    getTutorCategoryDetailsApiSuccess: (state, { payload }) => {
      state.tutorCategoryDetailsLoading = false
      state.tutorCategoryDetails = payload?.payload?.data || {}
    },
    getTutorCategoryDetailsApiFailed: (state, { payload }) => {
      state.tutorCategoryDetailsLoading = false
      state.ApiError = payload?.message
    },

    addTutorCategoryApiData: (state) => {
      state.tutorCategoryListLoading = true
      state.updateTutorCategory = false
      state.modalOpen = false
    },
    addTutorCategoryApiSuccess: (state, { payload }) => {
      state.tutorCategoryListLoading = false
      state.updateTutorCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    addTutorCategoryApiFailed: (state, { payload }) => {
      state.tutorCategoryListLoading = false
      state.updateTutorCategory = false
      state.ApiError = payload?.message
    },

    updateTutorCategoryApiData: (state, { payload }) => {
      state.updateTutorCategory = false
      state.tutorCategoryList = state.tutorCategoryList.map((item) =>
        item.id === payload?.id ? { ...item, ...payload } : item,
      )
    },
    updateTutorCategoryApiSuccess: (state, { payload }) => {
      state.updateTutorCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    updateTutorCategoryApiFailed: (state, { payload }) => {
      state.updateTutorCategory = false
      state.ApiError = payload?.message
    },

    deleteTutorCategoryApiData: (state, { payload }) => {
      state.tutorCategoryList = state.tutorCategoryList?.filter((item) => item.id !== payload?.id)
      state.updateTutorCategory = false
    },
    deleteTutorCategoryApiSuccess: (state, { payload }) => {
      state.updateTutorCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    deleteTutorCategoryApiFailed: (state, { payload }) => {
      state.updateTutorCategory = false
      state.ApiError = payload?.message
    },

    activeInactiveTutorCategoryApiData: (state) => {
      state.tutorCategoryListLoading = true
      state.updateTutorCategory = false
    },
    activeInactiveTutorCategoryApiSuccess: (state, { payload }) => {
      state.tutorCategoryListLoading = false
      state.updateTutorCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      if (payload?.payload?.data) {
        const updated = payload.payload.data
        state.tutorCategoryList = state.tutorCategoryList.map((item) =>
          item.id === updated.id ? { ...item, is_active: updated.is_active } : item,
        )
      }
    },
    activeInactiveTutorCategoryApiFailed: (state, { payload }) => {
      state.tutorCategoryListLoading = false
      state.updateTutorCategory = false
      state.ApiError = payload?.message
    },

    // ================= Tutor Sub Category (full CRUD) =================
    getTutorSubCategoryListApiData: (state) => {
      state.tutorSubCategoryListLoading = true
    },
    getTutorSubCategoryListApiSuccess: (state, { payload }) => {
      state.tutorSubCategoryListLoading = false
      state.tutorSubCategoryList = payload?.payload?.data || []
      state.tutorSubCategoryPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getTutorSubCategoryListApiFailed: (state, { payload }) => {
      state.tutorSubCategoryListLoading = false
      state.ApiError = payload?.message
    },

    getTutorSubCategoryDetailsApiData: (state) => {
      state.tutorSubCategoryDetailsLoading = true
    },
    getTutorSubCategoryDetailsApiSuccess: (state, { payload }) => {
      state.tutorSubCategoryDetailsLoading = false
      state.tutorSubCategoryDetails = payload?.payload?.data || {}
    },
    getTutorSubCategoryDetailsApiFailed: (state, { payload }) => {
      state.tutorSubCategoryDetailsLoading = false
      state.ApiError = payload?.message
    },

    addTutorSubCategoryApiData: (state) => {
      state.tutorSubCategoryListLoading = true
      state.updateTutorSubCategory = false
      state.modalOpen = false
    },
    addTutorSubCategoryApiSuccess: (state, { payload }) => {
      state.tutorSubCategoryListLoading = false
      state.updateTutorSubCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    addTutorSubCategoryApiFailed: (state, { payload }) => {
      state.tutorSubCategoryListLoading = false
      state.updateTutorSubCategory = false
      state.ApiError = payload?.message
    },

    updateTutorSubCategoryApiData: (state, { payload }) => {
      state.updateTutorSubCategory = false
      state.tutorSubCategoryList = state.tutorSubCategoryList.map((item) =>
        item.id === payload?.id ? { ...item, ...payload } : item,
      )
    },
    updateTutorSubCategoryApiSuccess: (state, { payload }) => {
      state.updateTutorSubCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    updateTutorSubCategoryApiFailed: (state, { payload }) => {
      state.updateTutorSubCategory = false
      state.ApiError = payload?.message
    },

    deleteTutorSubCategoryApiData: (state, { payload }) => {
      state.tutorSubCategoryList = state.tutorSubCategoryList?.filter((item) => item.id !== payload?.id)
      state.updateTutorSubCategory = false
    },
    deleteTutorSubCategoryApiSuccess: (state, { payload }) => {
      state.updateTutorSubCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    deleteTutorSubCategoryApiFailed: (state, { payload }) => {
      state.updateTutorSubCategory = false
      state.ApiError = payload?.message
    },

    activeInactiveTutorSubCategoryApiData: (state) => {
      state.tutorSubCategoryListLoading = true
      state.updateTutorSubCategory = false
    },
    activeInactiveTutorSubCategoryApiSuccess: (state, { payload }) => {
      state.tutorSubCategoryListLoading = false
      state.updateTutorSubCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      if (payload?.payload?.data) {
        const updated = payload.payload.data
        state.tutorSubCategoryList = state.tutorSubCategoryList.map((item) =>
          item.id === updated.id ? { ...item, is_active: updated.is_active } : item,
        )
      }
    },
    activeInactiveTutorSubCategoryApiFailed: (state, { payload }) => {
      state.tutorSubCategoryListLoading = false
      state.updateTutorSubCategory = false
      state.ApiError = payload?.message
    },

    // ================= Tutor Curriculum (full CRUD) =================
    getTutorCurriculumListApiData: (state) => {
      state.tutorCurriculumListLoading = true
    },
    getTutorCurriculumListApiSuccess: (state, { payload }) => {
      state.tutorCurriculumListLoading = false
      state.tutorCurriculumList = payload?.payload?.data || []
      state.tutorCurriculumPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getTutorCurriculumListApiFailed: (state, { payload }) => {
      state.tutorCurriculumListLoading = false
      state.ApiError = payload?.message
    },

    getTutorCurriculumDetailsApiData: (state) => {
      state.tutorCurriculumDetailsLoading = true
    },
    getTutorCurriculumDetailsApiSuccess: (state, { payload }) => {
      state.tutorCurriculumDetailsLoading = false
      state.tutorCurriculumDetails = payload?.payload?.data || {}
    },
    getTutorCurriculumDetailsApiFailed: (state, { payload }) => {
      state.tutorCurriculumDetailsLoading = false
      state.ApiError = payload?.message
    },

    addTutorCurriculumApiData: (state) => {
      state.tutorCurriculumListLoading = true
      state.updateTutorCurriculum = false
      state.modalOpen = false
    },
    addTutorCurriculumApiSuccess: (state, { payload }) => {
      state.tutorCurriculumListLoading = false
      state.updateTutorCurriculum = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    addTutorCurriculumApiFailed: (state, { payload }) => {
      state.tutorCurriculumListLoading = false
      state.updateTutorCurriculum = false
      state.ApiError = payload?.message
    },

    updateTutorCurriculumApiData: (state, { payload }) => {
      state.updateTutorCurriculum = false
      state.tutorCurriculumList = state.tutorCurriculumList.map((item) =>
        item.id === payload?.id ? { ...item, ...payload } : item,
      )
    },
    updateTutorCurriculumApiSuccess: (state, { payload }) => {
      state.updateTutorCurriculum = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    updateTutorCurriculumApiFailed: (state, { payload }) => {
      state.updateTutorCurriculum = false
      state.ApiError = payload?.message
    },

    deleteTutorCurriculumApiData: (state, { payload }) => {
      state.tutorCurriculumList = state.tutorCurriculumList?.filter((item) => item.id !== payload?.id)
      state.updateTutorCurriculum = false
    },
    deleteTutorCurriculumApiSuccess: (state, { payload }) => {
      state.updateTutorCurriculum = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    deleteTutorCurriculumApiFailed: (state, { payload }) => {
      state.updateTutorCurriculum = false
      state.ApiError = payload?.message
    },

    activeInactiveTutorCurriculumApiData: (state) => {
      state.tutorCurriculumListLoading = true
      state.updateTutorCurriculum = false
    },
    activeInactiveTutorCurriculumApiSuccess: (state, { payload }) => {
      state.tutorCurriculumListLoading = false
      state.updateTutorCurriculum = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      if (payload?.payload?.data) {
        const updated = payload.payload.data
        state.tutorCurriculumList = state.tutorCurriculumList.map((item) =>
          item.id === updated.id ? { ...item, is_active: updated.is_active } : item,
        )
      }
    },
    activeInactiveTutorCurriculumApiFailed: (state, { payload }) => {
      state.tutorCurriculumListLoading = false
      state.updateTutorCurriculum = false
      state.ApiError = payload?.message
    },

    // ================= Tutor List (list / details / status / verification) =================
    getTutorListApiData: (state) => {
      state.tutorListLoading = true
    },
    getTutorListApiSuccess: (state, { payload }) => {
      state.tutorListLoading = false
      state.tutorList = payload?.payload?.data || []
      state.tutorPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getTutorListApiFailed: (state, { payload }) => {
      state.tutorListLoading = false
      state.ApiError = payload?.message
    },

    getTutorDetailsApiData: (state) => {
      state.tutorDetailsLoading = true
      state.tutorDetails = {}
    },
    getTutorDetailsApiSuccess: (state, { payload }) => {
      state.tutorDetailsLoading = false
      state.tutorDetails = payload?.payload?.data || {}
    },
    getTutorDetailsApiFailed: (state, { payload }) => {
      state.tutorDetailsLoading = false
      state.ApiError = payload?.message
    },

    activeInactiveTutorApiData: (state) => {
      state.tutorListLoading = true
      state.updateTutor = false
      state.modalOpen = false
    },
    activeInactiveTutorApiSuccess: (state, { payload }) => {
      state.tutorListLoading = false
      state.updateTutor = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      if (payload?.payload?.data?.id) {
        const updated = payload.payload.data
        state.tutorList = state.tutorList.map((item) =>
          item.id === updated.id ? { ...item, is_active: updated.is_active } : item,
        )
      }
    },
    activeInactiveTutorApiFailed: (state, { payload }) => {
      state.tutorListLoading = false
      state.updateTutor = false
      state.modalOpen = true
      state.ApiError = { error: true, message: payload?.message || 'Something went wrong' }
    },

    // Approve / Reject (status decides the action)
    tutorVerificationApiData: (state) => {
      state.tutorVerificationLoading = true
      state.updateTutor = false
      state.modalOpen = false
    },
    tutorVerificationApiSuccess: (state, { payload }) => {
      state.tutorVerificationLoading = false
      state.updateTutor = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    tutorVerificationApiFailed: (state, { payload }) => {
      state.tutorVerificationLoading = false
      state.modalOpen = true
      const message = payload?.message || 'Something went wrong'
      if (payload?.reviewReopened) {
        // step 1 (reopen) worked, step 2 failed -> tutor is Pending now, reload the list so the admin sees it
        state.updateTutor = true
        state.ApiError = {
          error: true,
          message: `${message}. The tutor is now Pending, please approve / reject again.`,
        }
      } else {
        state.updateTutor = false
        state.ApiError = { error: true, message }
      }
    },

    // ================= State (tutor list filter) =================
    getTutorStateListApiData: (state) => {
      state.tutorStateListLoading = true
    },
    getTutorStateListApiSuccess: (state, { payload }) => {
      state.tutorStateListLoading = false
      state.tutorStateList = payload?.payload?.data || []
    },
    getTutorStateListApiFailed: (state, { payload }) => {
      state.tutorStateListLoading = false
      state.ApiError = payload?.message
    },

    // ================= Country (common list) =================
    getCountryListApiData: (state) => {
      state.countryListLoading = true
    },
    getCountryListApiSuccess: (state, { payload }) => {
      state.countryListLoading = false
      state.countryList = payload?.payload?.data || []
    },
    getCountryListApiFailed: (state, { payload }) => {
      state.countryListLoading = false
      state.ApiError = payload?.message
    },

    resetTutorError: (state) => {
      state.ApiError = ''
      state.modalOpen = false
    },
  },
})

export const {
  // Tutor Type
  getTutorTypeListApiData,
  getTutorTypeListApiSuccess,
  getTutorTypeListApiFailed,
  getTutorTypeDetailsApiData,
  getTutorTypeDetailsApiSuccess,
  getTutorTypeDetailsApiFailed,
  addTutorTypeApiData,
  addTutorTypeApiSuccess,
  addTutorTypeApiFailed,
  updateTutorTypeApiData,
  updateTutorTypeApiSuccess,
  updateTutorTypeApiFailed,
  deleteTutorTypeApiData,
  deleteTutorTypeApiSuccess,
  deleteTutorTypeApiFailed,
  activeInactiveTutorTypeApiData,
  activeInactiveTutorTypeApiSuccess,
  activeInactiveTutorTypeApiFailed,

  // Tutor Category
  getTutorCategoryListApiData,
  getTutorCategoryListApiSuccess,
  getTutorCategoryListApiFailed,
  getTutorCategoryDetailsApiData,
  getTutorCategoryDetailsApiSuccess,
  getTutorCategoryDetailsApiFailed,
  addTutorCategoryApiData,
  addTutorCategoryApiSuccess,
  addTutorCategoryApiFailed,
  updateTutorCategoryApiData,
  updateTutorCategoryApiSuccess,
  updateTutorCategoryApiFailed,
  deleteTutorCategoryApiData,
  deleteTutorCategoryApiSuccess,
  deleteTutorCategoryApiFailed,
  activeInactiveTutorCategoryApiData,
  activeInactiveTutorCategoryApiSuccess,
  activeInactiveTutorCategoryApiFailed,

  // Tutor Sub Category
  getTutorSubCategoryListApiData,
  getTutorSubCategoryListApiSuccess,
  getTutorSubCategoryListApiFailed,
  getTutorSubCategoryDetailsApiData,
  getTutorSubCategoryDetailsApiSuccess,
  getTutorSubCategoryDetailsApiFailed,
  addTutorSubCategoryApiData,
  addTutorSubCategoryApiSuccess,
  addTutorSubCategoryApiFailed,
  updateTutorSubCategoryApiData,
  updateTutorSubCategoryApiSuccess,
  updateTutorSubCategoryApiFailed,
  deleteTutorSubCategoryApiData,
  deleteTutorSubCategoryApiSuccess,
  deleteTutorSubCategoryApiFailed,
  activeInactiveTutorSubCategoryApiData,
  activeInactiveTutorSubCategoryApiSuccess,
  activeInactiveTutorSubCategoryApiFailed,

  // Tutor Curriculum
  getTutorCurriculumListApiData,
  getTutorCurriculumListApiSuccess,
  getTutorCurriculumListApiFailed,
  getTutorCurriculumDetailsApiData,
  getTutorCurriculumDetailsApiSuccess,
  getTutorCurriculumDetailsApiFailed,
  addTutorCurriculumApiData,
  addTutorCurriculumApiSuccess,
  addTutorCurriculumApiFailed,
  updateTutorCurriculumApiData,
  updateTutorCurriculumApiSuccess,
  updateTutorCurriculumApiFailed,
  deleteTutorCurriculumApiData,
  deleteTutorCurriculumApiSuccess,
  deleteTutorCurriculumApiFailed,
  activeInactiveTutorCurriculumApiData,
  activeInactiveTutorCurriculumApiSuccess,
  activeInactiveTutorCurriculumApiFailed,

  // Tutor List
  getTutorListApiData,
  getTutorListApiSuccess,
  getTutorListApiFailed,
  getTutorDetailsApiData,
  getTutorDetailsApiSuccess,
  getTutorDetailsApiFailed,
  activeInactiveTutorApiData,
  activeInactiveTutorApiSuccess,
  activeInactiveTutorApiFailed,
  tutorVerificationApiData,
  tutorVerificationApiSuccess,
  tutorVerificationApiFailed,

  // State (tutor list filter)
  getTutorStateListApiData,
  getTutorStateListApiSuccess,
  getTutorStateListApiFailed,

  // Country (common)
  getCountryListApiData,
  getCountryListApiSuccess,
  getCountryListApiFailed,

  resetTutorError,
} = slice.actions

export default slice.reducer
